import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Select, {Async} from 'react-select';
import {gettext} from 'utils/text';


class SelectField extends React.Component {
    /* Form group for selects.
     *
     * Displays a react-select.Select when `options` property is passed and a react-select.Async when `loadOptions`
     * property is passed to load options asynchronously.
     */
    static propTypes = {
        autoload: PropTypes.bool,
        cssClass: PropTypes.string,
        error: PropTypes.string,
        label: PropTypes.string,
        loadOptions: PropTypes.func,
        name: PropTypes.string.isRequired,
        options: PropTypes.arrayOf(PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired,
        })),
        onBlur: PropTypes.func,
        onChange: PropTypes.func,
        touched: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
        value: PropTypes.shape({
            label: PropTypes.string,
            value: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number,
            ]),
        }),
        disabled: PropTypes.bool,
    };

    static defaultProps = {
        autoload: true,
        cssClass: null,
        error: '',
        label: null,
        loadOptions: undefined,
        options: undefined,
        onBlur: () => {},
        onChange: () => {},
        touched: true,
        value: null,
        disabled: false,
    };

    render() {
        const touchedError = this.props.touched && this.props.error;
        const formGroupClasses = classnames('form-group', this.props.cssClass);
        const formControlClasses = classnames({'is-invalid': touchedError});
        const selectProps = {
            id: this.props.name,
            name: this.props.name,
            value: this.props.value,
            autosize: false,
            className: formControlClasses,
            onBlur: () => this.props.onBlur(this.props.name, true),
            onChange: option => this.props.onChange(this.props.name, option),
            placeholder: gettext('Select...'),
            loadingPlaceholder: gettext('Loading...'),
            clearAllText: gettext('Clear all'),
            clearValueText: gettext('Clear value'),
            noResultsText: gettext('No results found'),
            searchPromptText: gettext('Type to search'),
        };
        return (
            <div className={formGroupClasses}>
                {this.props.label ? <label htmlFor={this.props.name}>{this.props.label}</label> : null}
                {this.props.options && !this.props.disabled ?
                    <Select {...selectProps} options={this.props.options} /> : null}
                {this.props.loadOptions && !this.props.disabled ?
                    <Async
                        {...selectProps}
                        autoload={this.props.autoload}
                        loadOptions={this.props.loadOptions}
                        filterOptions={options => options}
                        ignoreCase={false}
                        ignoreAccents={false}
                    /> : null}
                {this.props.disabled ?
                    <input
                        id={this.props.name}
                        name={this.props.name}
                        className="form-control"
                        value={this.props.value !== null ? this.props.value.label : ''}
                        disabled={this.props.disabled}
                    /> : null}
                {touchedError && <div className="invalid-feedback">{touchedError}</div>}
            </div>
        );
    }
}

export default SelectField;



// WEBPACK FOOTER //
// ./src/components/SelectField.js